<template>
  <div class="page">
    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->

    <div class="spacer-25"></div>

    <div v-if="!loaded">
      <v-skeleton-loader
        class="mx-auto"
        max-width="600"
        type="card"
      ></v-skeleton-loader>
    </div>

    <v-container grid-list-xl v-else>
      <v-layout row wrap>
        <v-flex xs12 sm8 lg10 offset-sm-2 offset-lg-1>
          <NewsCard
            :class="{pointer: hasDeepLink}"
            @click.native.passive="clickLink"
            :news="beitrag" :show-all="true"></NewsCard>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as util from '../vendor/util';
import NewsCard from "../news/NewsCard";

export default {
  components: {NewsCard},
  data() {
    return {
      loaded: false,
      beitrag: {},
      // currentTag: '',
    }
  },
  computed: {
    hasDeepLink() {
      return !!this.beitrag.link;
    }
  },
  // watch: {
  //     '$route.params.tag'(tag) {
  //         if (tag && tag !== this.currentTag) {
  //             this.currentTag = '' + tag;
  //             this.init();
  //         }
  //     },
  // },
  mounted() {
    // this.showBigImage = false;
    // this.currentTag = '';
    this.init();
    setTimeout(() => {
      if (!this.loaded) {
        ebus.$emit('loadNews');
        this.init();
      }
    }, 3000);
  },
  destroyed() {
    this.loaded = false;
    // this.currentTag = '';
    // this.currentCategory = '';
  },

  methods: {
    init() {
      this.loaded = false;
      this.id = '' + this.$route.params.newsId;
      let _b = store.getters.getNewsById(this.$route.params.newsId);
      if (_b) {
        let b = util.cloneMe(_b);
        this.beitrag = b;
        setTimeout(() => {
          this.loaded = true;
        }, 100);
      } else {
        ebus.$emit('loadNews');
      }
    },
    clickLink() {
      if (this.hasDeepLink) {
        try {
          let l = this.beitrag.link;
          l = l.substring(l.indexOf('#') + 2, l.length);

          if (l.startsWith('Speise')) {
            let iid = l.substring(7, l.length);
            // alert(iid);
            this.$router.push({name: 'Speise', params: {itemId: iid}});
          } else {
            let resolved = this.$router.resolve(l);
            if (resolved.route.name !== '404') {
              this.$router.push({name: l});
            } else {
              console.log('route resolved to 404');
              ebus.$emit('gotoWebsite', this.beitrag.link);
            }
          }
        } catch (e) {
          console.log('error in link parsing: ' + e.message);
        }

        // }else  if(l.startsWith('Speise')){
        //     let iid = l.substring(7,l.length);
        //     alert(iid);
        //     this.$router.push({name: 'Speise', params: {itemId: iid}});
        // }


        // window.location = this.news.link;
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>
